/**
 * calculate day
 * @param {Number} day - new Date().getDay()
 */
export const calcDay = (day) => {
  let week = '';

  switch (day) {
    case 0:
      week = '周日';
      break;
    case 1:
      week = '周一';
      break;
    case 2:
      week = '周二';
      break;
    case 3:
      week = '周三';
      break;
    case 4:
      week = '周四';
      break;
    case 5:
      week = '周五';
      break;
    case 6:
      week = '周六';
      break;
    default:
      week = '';
  }

  return week;
};

export const getRepeatRateOptions = (curTime = new Date()) => ['每天', '每个工作日', `每周（${calcDay(curTime.getDay())}）`, `每两周（${calcDay(curTime.getDay())}）`, `每月（${curTime.getDate()}日）`];
